export default __webpack_public_path__ + "static/media/christmasLogoSingle.5c05cd80.png";